import { HashRouter } from "react-router-dom";
import RouterView from "./router";

import "./App.css";

function App() {
	return (
		<HashRouter>
			<RouterView />
		</HashRouter>
	);
}

export default App;
